import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useForm } from "react-hook-form";
import { comboQR } from "../../utils/actions";

//COMPONENTS
import AlertComponent from "../../../../components/common/alert";
import GlobalButton from "../../../../components/common/GlobalButton";
import Title from "../../../../components/Title";
import Subtitle from "../../../../components/Subtitle";
import Tips from "../../../../components/Tips";
import Checkbox from "../../../../components/Checkbox";

//STYLES
import { Container, CustomLabel, CustomLabelLeft, TittleContainer } from "./styles";

export const Logo = () => {
  const dispatch = useDispatch();
  const { handleSubmit, register } = useForm();

  const handleClose = (event, reason) => setAlert(false);
  const exist = useSelector((state) => state.comboQR.setSelUserLogo);

  const [openAlert, setAlert] = useState(false);
  ///////////
  const checked = useSelector((state) => state.comboQR.setCheckLogoQR);

  const handleCheck = () => {
    dispatch(comboQR.setCheckLogoQR(!checked));

    if (checked) {
      dispatch(comboQR.setSelUserLogo(false));
    } else {
      dispatch(comboQR.setSelUserLogo(true));
      dispatch(comboQR.setLogo({}));
    }
  };
  ////////
  const onSubmit = (values) => {
    if (checked || Object.keys(values.logo).length > 0) {
      dispatch(comboQR.setEtapa("description"));
      dispatch(comboQR.setSelUserLogo(true));
    } /* else if (exist) dispatch(comboQR.setEtapa("description")); */ else setAlert(true);
  };

  const onChangeLogo = (e) => {
    if (e.target.files[0]) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        dispatch(comboQR.setLogo(reader.result));
        dispatch(comboQR.setSelUserLogo(true));
        dispatch(comboQR.setCheckLogoQR(false));
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <Container>
      <div>
        <TittleContainer>
          <Title text="Cargá tu logo" />
        </TittleContainer>

        <Subtitle notmr text={"· Sólo archivos .jpg y .png"} />
        <Subtitle notmr text={"· Peso máximo 350kb."} />
      </div>

      <AlertComponent open={openAlert} color="warning" onClose={handleClose} message="Seleccione algun logo de su galeria." />

      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ disply: "flex", height: "30px" }}>
          <div style={{ display: "flex", flexDirection: "row", height: "30px" }}>
            <CustomLabelLeft>archivo.jpg</CustomLabelLeft>
            <CustomLabel htmlFor="logo">EXAMINAR...</CustomLabel>
          </div>

          <input id="logo" name="logo" ref={register} type="file" onChange={onChangeLogo} style={{ display: "none" }} />
        </div>

        {/* /////// */}

        <label style={{ lineHeight: 0 }}>
          <Checkbox checked={checked} onChange={handleCheck} inputWidth="12px" inputHeight="12px" />
          <span
            style={{
              lineHeight: "16px",
              verticalAlign: "middle",
              marginLeft: 8,
              fontFamily: "GilroyMedium",
              fontSize: 16,
            }}
          >
            continuar sin logo
          </span>
        </label>

        {/* ////////// */}

        <div style={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
          <GlobalButton content="SIGUIENTE" disabled={!exist} />
        </div>
      </form>

      <div>
        <Tips texts={["Verificá que las fotos no estén en baja resolución (pixeladas o fuera de foco)."]} />
      </div>
    </Container>
  );
};
